import shopifyGenericDefaults from '../shopify-generic/config.js';
import { getLicensePlateResponse, getVinResponse, initHelpers, parseVehicleFromFacets } from './helpers.js';

const keywordsSearchPage = '/pages/keywords-search';
const isDifferentialWizardPage = Boolean(window.document.querySelector('#cm-diff-wizard'));
const isProductPage = window.Convermax.Shopify?.getPageType() === 'product';

window.Convermax.isDifferentialCollectionPage =
  window.Convermax.Shopify?.getPageType() === 'collection' &&
  /\/diff-\d+\/?$/i.test(window.location.pathname);

const baseFitmentFields = shopifyGenericDefaults.fitmentSearch.baseFields;
const extraFitmentFields = shopifyGenericDefaults.fitmentSearch.extraFields;
const fitmentFields = [...baseFitmentFields, ...extraFitmentFields];
const fitmentFieldsWithoutDiff = [...baseFitmentFields, ...extraFitmentFields].filter(
  (f) => f !== 'Differential',
);
const differentialWizardFields = [...baseFitmentFields, 'Drive'];

const sortFields = [
  'relevance',
  'published_at:desc',
  'order_count:desc',
  'price',
  'price:desc',
  'title',
  'title:desc',
];
window.Convermax.sortFields = sortFields;
window.Convermax.toggleDifferentialWizardGroup = (event, differentialCode) => {
  const groupItems = Array.from(
    window.document.querySelectorAll('.cm_DifferentialSearchPage [data-differential-wizard-group]'),
  ).filter((item) => item.dataset.differentialWizardGroup === differentialCode);

  if (!groupItems.length) {
    return;
  }

  const isExpanded = groupItems.some((item) => !item.classList.contains('cm_hide'));
  const shouldExpand = !isExpanded;

  groupItems.forEach((item) => item.classList.toggle('cm_hide', !shouldExpand));
  event.currentTarget.classList.toggle('cm_differential-wizard_group-header__open', shouldExpand);
  event.currentTarget.setAttribute('aria-expanded', String(shouldExpand));
};
const sortDialogActiveItemClass = 'cm_sort-dialog_list-item_active';
window.Convermax.handleSortDialogOptionClick = (e, sortOption) => {
  window.Convermax.setSearchSort(sortOption);

  window.document.querySelector(`.${sortDialogActiveItemClass}`)?.classList.remove(sortDialogActiveItemClass);
  e.target.classList.add(sortDialogActiveItemClass);
};
window.Convermax.handleSortDialogClearClick = () => {
  window.Convermax.setSearchSort(sortFields[0]);

  window.document.querySelector(`.${sortDialogActiveItemClass}`)?.classList.remove(sortDialogActiveItemClass);
  window.document.querySelector('.cm_sort-dialog_list-item').classList.add(sortDialogActiveItemClass);
};

initHelpers({ YMMTabSelector: 'tab-btn1' });
// our serchbox doesn't know how not to redirect,
// and we don't have a separate component for vinsearchbox,
// so we made the request sending through the helper.
// the theme contains only the layout that pulls this function.
window.Convermax.getVinResponse = async (query) => await getVinResponse(query, fitmentFields);

// the same here as above
window.Convermax.getLicensePlateResponse = async (state, licensePlate) =>
  await getLicensePlateResponse(state, licensePlate, fitmentFields);

window.Convermax.getVehicleLabelWithoutDifferential = (vehicle = {}) => {
  return Object.entries(vehicle)
    .filter(([field]) => field !== 'Differential')
    .map(([, value]) => value)
    .join(' ');
};

window.Convermax.handleCustomSearchBox = (e, query) => {
  if (e.key !== 'Enter') {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const searchBoxContainer = e.target.closest('.cm_search-box-root')?.children[0];
  if (!searchBoxContainer) {
    return;
  }

  if (searchBoxContainer.classList.contains('cm_search-box-root__vin-number')) {
    window.Convermax.getVinResponse(query);
  } else if (searchBoxContainer.classList.contains('cm_search-box-root__license-plate')) {
    window.Convermax.getLicensePlateResponse(
      searchBoxContainer.querySelector('#cm_license-plate-state')?.value,
      query,
    );
  }
};

shopifyGenericDefaults.Widgets.forEach((w) => {
  if (w.type === 'FacetPanel' || w.name === 'FacetDialog') {
    if (w.ignoreFields) {
      w.ignoreFields.push('differential_brands');
    } else {
      w.ignoreFields = ['differential_brands'];
    }
  }
});

window.Convermax.onLicensePlateStateChange = (state, licensePlate) => {
  const searchButton = window.document.getElementById('cm_license-plate-search-button');
  searchButton?.classList.toggle('cm_disabled', !state || !licensePlate);
};

window.Convermax.searchByLicensePlate = (state, licensePlate, setQuery) => {
  if (state && licensePlate) {
    window.Convermax.discardVehicle();

    const licensePlateQuery = `state:${state}; license plate: ${licensePlate}`;
    setQuery(licensePlateQuery);
  }
};

window.Convermax.showToggleTooltip = (e) => {
  e.preventDefault();
  e.stopPropagation();

  const tooltipContent = e.target.nextSibling;

  if (tooltipContent) {
    tooltipContent.classList.toggle('cm_hide');
  }
};

window.Convermax.hideTooltip = () => {
  const tooltipContent = document.querySelector('.differential-tooltip');

  if (tooltipContent) {
    tooltipContent.classList.add('cm_hide');
  }
};

window.Convermax.onKeywordsSearchSubmit = (event, searchBox) => {
  searchBox.preventFormSubmission(event);

  const form = event.target;
  const values = [...form.querySelectorAll('.cm_keywords_input')]
    .map((input) => input.value.trim())
    .filter(Boolean);

  if (values.length > 0) {
    const keywordsQuery = `keywords:${values.join(';')}`;
    searchBox.setQuery(keywordsQuery);
  }
};

window.Convermax.handleDifferentialBrandSelection = (component, entry) => {
  if (!entry.selected) {
    component.onChange(entry.term);
  }

  window.document.querySelector('#cm_DifferentialBrandSelectionDialog')?.click();
};

window.Convermax.dialogRedirectToDifferentialCollectionPage = (e) => {
  const dialogEl = e.target.closest('.cm_dialog');
  const differentialSelect = dialogEl.querySelector('.cm_select:last-child select');

  if (differentialSelect?.value) {
    window.location.assign(
      `${window.Convermax.Shopify?.getCollectionsPageUrl()}/${differentialSelect.value}`.toLocaleLowerCase(),
    );
  }
};

window.Convermax.onHomeTabClick = (tabId) => {
  if (!tabId) {
    return;
  }

  const targetTab = window.document.getElementById(tabId);
  const newContent = window.document.querySelector(`#content-tabs .tabcontent[aria-labelledby="${tabId}"]`);
  if (!targetTab || !newContent) {
    return;
  }

  const currentActiveTabs = window.document.querySelectorAll('#content-tabs .tablink.active');
  const currentActiveContents = window.document.querySelectorAll('#content-tabs .tabcontent.open');

  currentActiveTabs.forEach((tab) => {
    tab.classList.remove('active');
  });

  currentActiveContents.forEach((content) => {
    content.classList.remove('open');
  });

  targetTab.classList.add('active');
  if (newContent) {
    newContent.classList.add('open');
  }
};

window.Convermax.onDialogTabClick = (tabClass, e) => {
  const targetTab = tabClass
    ? window.document.querySelector(`.cm_tab-title.${tabClass}`)
    : e && e.target
      ? e.target.closest('.cm_tab-title')
      : null;

  if (!targetTab || targetTab.classList.contains('active')) {
    return;
  }

  const tabId = [...targetTab.classList].find((cls) => cls.startsWith('cm_') && cls !== 'cm_tab-title');
  const newContent = window.document.querySelector(`.cm_tab-content.${tabId}`);
  if (!tabId || !newContent) {
    return;
  }

  const currentActiveTab = window.document.querySelector('.cm_tab-title.active');
  const currentActiveContent = window.document.querySelector('.cm_tab-content.active');

  if (currentActiveTab) {
    currentActiveTab.classList.remove('active');
  }
  if (currentActiveContent) {
    currentActiveContent.classList.remove('active');
  }

  targetTab.classList.add('active');
  if (newContent) {
    newContent.classList.add('active');
  }
};

window.Convermax.openGarageDialog = (tabClass) => {
  window.Convermax.openVehicleDialog();

  if (tabClass) {
    // a timeout is needed because the dialog should be opened
    setTimeout(() => {
      window.Convermax.onDialogTabClick(tabClass);
    }, 0);
  }
};

window.Convermax.closeGarageDialog = () => {
  const dialogCloseButton = window.document.querySelector('.cm_dialog.GarageDialog .close');
  if (dialogCloseButton) {
    dialogCloseButton.click();
  }
};

function responseHandler(response) {
  const isListCollectionsPage = document.body.classList.contains('template-list-collections');

  if (!isListCollectionsPage) {
    const differentialFacet = response.Facets.find(
      (facet) => facet.FieldName === 'Differential' && facet.Values.length,
    );

    document.body.classList.toggle('cm_show-differential', !!differentialFacet);
  }

  const garageDialog = window.document.querySelector('.cm_dialog.GarageDialog');
  const isGarageDialogOpened = !!garageDialog?.children.length;
  const isVinSearchResponse = response.Extra.VinEntered;

  if (isGarageDialogOpened && isVinSearchResponse) {
    const messages = response.Messages;

    if (!messages.length) {
      window.Convermax.closeGarageDialog();
    }
  }
  if (isVinSearchResponse) {
    const { Facets: facets = [] } = response;
    const { vehicle, missingFields } = parseVehicleFromFacets(facets, [
      ...baseFitmentFields,
      ...extraFitmentFields,
    ]);

    if (missingFields.length) {
      // a timeout is needed because the dialog should be opened
      setTimeout(() => {
        window.Convermax.setVehicle(vehicle);
        window.Convermax.openGarageDialog('cm_vehicle-search');
      }, 0);
    }
  }

  return response;
}

function getLocalPreselection(pageType, defaults) {
  const preselection =
    window.Convermax.isDifferentialCollectionPage || window.Convermax.isDifferentialCollectionPage
      ? [{ field: 'FilterByVehicle', term: 'False' }]
      : [];

  if (window.Convermax.isDifferentialCollectionPage) {
    preselection.push({ field: 'differential_codes', term: window.location.pathname.split('/').at(-1) });
  }

  return [...(defaults.getter(pageType) ?? []), ...preselection];
}

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  sortFields,
  infiniteScrollEnabled: false,
  getLocalPreselection,
  SearchRequestDefaults: {
    ...shopifyGenericDefaults.SearchRequestDefaults,
    ...(isDifferentialWizardPage ? { pageSize: 10000 } : {}),
    extra: {
      ...shopifyGenericDefaults.SearchRequestDefaults.extra,
      isDifferentialFieldAllowed: window.location.pathname === '/pages/search',
      ...(isDifferentialWizardPage ? { isDifferentialWizardPage: true } : {}),
    },
  },
  product: {
    noImageSrc: window.Convermax.config?.noImageSrc,
  },
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    isExtraFieldsAlwaysVisible: true,
  },
  responseHandler,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchBox',
          'SearchBoxDialogButton',
          'SearchVehicleWidget',
          'MobileGarage',
          'VerifyFitment',
          'FitmentTable',
          'VehicleWidgetDialog',
          'CategoryPageCategoriesGrid',
          'CategoryPageCategoriesCarousel',
          'HomeVehicleWidget_tab',
          'SearchBox_tab',
        ].includes(w.name),
    ),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      visibleIf: { ignoreUrls: [keywordsSearchPage] },
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBoxDialogButton'),
      template: 'searchBox/dialogButtonAdaptable',
      visibleIf: { ignoreUrls: [keywordsSearchPage] },
    },
    {
      name: 'SearchBox_keywords',
      type: 'SearchBox',
      disableDropdown: true,
      redirectUrl: keywordsSearchPage,
    },
    {
      name: 'SearchBox_tab',
      type: 'SearchBox',
      disableDropdown: true,
      onSubmit: () => window.Convermax.onDialogTabClick('cm_vehicle-search'),
    },
    {
      name: 'KeywordsSearchPage',
      type: 'SearchPage',
      location: '#cm-keywords-search',
      template: 'KeywordsSearchPage',
      visibleIf: { urls: [keywordsSearchPage] },
    },
    {
      name: 'DifferentialWizardPage',
      type: 'SearchPage',
      location: '#cm-diff-wizard',
      template: 'DifferentialSearchPage',
    },
    {
      name: 'DifferentialWizardVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
      fields: differentialWizardFields,
      doNotRedirectOnVehicleSelect: true,
      useNativeDropdown: false,
      useSearchableDropdown: true,
    },
    {
      name: 'SubCategoriesTiles',
      type: 'FacetTiles',
      visibleIf: () => window.Convermax.Shopify.getPageType() === 'collection',
      facetField: 'category',
      view: window.innerWidth > 991 ? 'grid' : 'carousel',
    },
    {
      name: 'DifferentialMakesFacetPanel',
      type: 'FacetPanel',
      fields: ['differential_brands'],
    },
    {
      name: 'DifferentialByMakeFacetPanel',
      type: 'FacetPanel',
      disableCollapse: true,
      fields: ['differential_codes'],
      showAllAlways: true,
      valuesCountToShowFilterInput: 5,
    },
    {
      name: 'DifferentialSelectionPage',
      type: 'SearchPage',
      location: '#cm-shop-by-diff',
      template: 'differentials/DifferentialSelectionPage',
    },
    {
      name: 'FilterChips__mobile',
      type: 'FacetPanel',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-home-ymm',
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysColumnLayout: true,
      fields: [...baseFitmentFields, ...extraFitmentFields],
      useNativeDropdown: false,
      useSearchableDropdown: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertBefore: '#cm_results, #cm-collection-page',
      },
      template: 'fitmentSearch/searchVehicleWidgetContainer',
      fields: fitmentFieldsWithoutDiff,
      visibleIf: () => !window.Convermax.isDifferentialCollectionPage,
    },
    {
      name: 'MobileGarageDialogButton',
      type: 'DialogButton',
      location: { selector: '#cm-mobile-garage', class: 'cm_garage__mobile' },
      template: 'fitmentSearch/mobileGarage',
      dialogName: 'VehicleWidgetDialog',
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
      isAlwaysColumnLayout: true,
    },
    {
      name: 'FitmentTable',
      location: '#cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
      columnBreakpoint: 900,
    },
    {
      name: 'DifferentialBrandSelectionRequestPanel',
      type: 'RequestPanel',
      isAutoRedirectDisabled: true,
      selectFields: ['differential_brands'],
    },
    {
      name: 'DifferentialDialogSelectionRequestPanel',
      type: 'RequestPanel',
      isAutoRedirectDisabled: true,
      selectFields: ['differential_brands', 'differential_codes'],
      requiredFields: ['differential_brands', 'differential_codes'],
      requestExtra: {
        isDifferentialDialogSelectionRequestPanel: 'true',
      },
      shouldBeIsolated: () => true,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'VehicleWidgetDialog'),
      location: { id: 'cm_GarageDialog', class: 'vehicle-dialog GarageDialog' },
      doNotRedirectOnVehicleSelect: isProductPage,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled: true,
      useSearchableDropdown: true,
    },
    {
      name: 'DifferentialVehicleDialog',
      type: 'VehicleWidgetDialog',
      template: 'fitmentSearch/differentialDialog',
      doNotRedirectOnVehicleSelect: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled: true,
    },
    {
      name: 'DifferentialBrandSelectionDialog',
      type: 'ContextDialog',
      template: 'differentials/DifferentialBrandSelectionDialog',
    },
    {
      name: 'DifferentialSelectionDialog',
      type: 'ContextDialog',
      template: 'differentials/DifferentialSelectionDialog',
    },
    {
      name: 'SortDialog',
      type: 'ContextDialog',
      template: 'main/sortDialog',
      closeOnClickOutside: false,
    },
  ],
};
